
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CmsserviceService } from 'src/app/common-cms-service/cmsservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

 
declare var $: any;


@Component({
  selector: 'app-ks-three-mock-test',
  imports: [CommonModule, RouterModule,
    FormsModule],
  templateUrl: './ks-three-mock-test.component.html',
  styleUrl: './ks-three-mock-test.component.css',
})
export class KsThreeMockTestComponent {
    title = 'KS3 Mock Test Calendar';
 
  // Fixed category IDs for KS3 — Year 7, Year 8, Year 9
  private readonly KS3_CATEGORY_IDS = [45, 46, 47];
 
  filters: any = {
    categoryId: null,
    mode: null,
    month: null,
    center: null,
    search: ''
  };
 
  months = [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 }
  ];
 
  categories: any[] = [];
  ks3Categories: any[] = [];
 
  centers: string[] = [];
 
  allTests: any[] = [];
  testList: any[] = [];
 
  visibleCount = 12;
 
  openFaq: number | null = null;
 
  private ngUnsubscribe = new Subject<void>();
 
  private preselectCategoryId: number | null = null;
 
  private shouldAutoScroll = false;
 
  whyCards = [
    {
      title: 'Real Exam Environment',
      text: 'Students experience actual school-assessment exam conditions.',
      icon: '📘'
    },
    {
      title: 'Detailed Feedback',
      text: 'Get personalised performance analysis and improvement guidance.',
      icon: '📊'
    },
    {
      title: 'Expert Teachers',
      text: 'Papers reviewed by experienced KS3 subject specialists.',
      icon: '🎓'
    },
    {
      title: 'Fast Results',
      text: 'Receive e-results and reports within 48 hours.',
      icon: '⚡'
    }
  ];
 
  features = [
    {
      title: 'Personalised Feedback',
      text: 'Understand strengths and weaknesses clearly.',
      icon: '📝'
    },
    {
      title: 'Past Papers Included',
      text: 'Extra revision material for additional practice.',
      icon: '📚'
    },
    {
      title: 'Doubt Clearing Session',
      text: 'Resolve mistakes and improve exam strategy.',
      icon: '💡'
    },
    {
      title: 'Result Analysis Report',
      text: 'Score, rank and percentile compared against peers.',
      icon: '📈'
    }
  ];
 
  testimonials = [
    {
      name: 'Sarah',
      location: 'London',
      text: 'The mock tests gave my child real confidence before their school exams.'
    },
    {
      name: 'Ahmed',
      location: 'Essex',
      text: 'Detailed reports helped identify weak areas quickly.'
    },
    {
      name: 'Priya',
      location: 'Birmingham',
      text: 'Excellent organisation and realistic exam conditions.'
    }
  ];
 
  faqs = [
    {
      q: 'How long are the mock tests?',
      a: 'The duration matches the actual school assessment timings for each year group.'
    },
    {
      q: 'Which year groups are covered?',
      a: 'Year 7, Year 8 and Year 9 mock tests are available.'
    },
    {
      q: 'Do students receive feedback?',
      a: 'Yes, every student receives a detailed Result Analysis Report.'
    },
    {
      q: 'Are online sessions available?',
      a: 'Yes, selected subjects are available online.'
    }
  ];
 
  constructor(
    private router: ActivatedRoute,
    private titleService: Title,
    private categoryProduct: CmsserviceService,
    private route: Router,
    private ref: ChangeDetectorRef
  ) {}
 
  ngOnInit() {
 
    this.titleService.setTitle(this.title);
 
    this.fetchTests();
 
    this.router.queryParams.subscribe(params => {
 
      if (params['category']) {
 
        const cid = Number(params['category']);
 
        if (!isNaN(cid)) {
          this.preselectCategoryId = cid;
          this.filters.categoryId = cid;
        }
      }
 
      if (params['scroll'] === 'calendar-section') {
        this.shouldAutoScroll = true;
      }
 
    });
 
    this.autoScorll();
 
  }
 
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
 
  // ============================================================
  // FETCH TESTS
  // ============================================================
 
  fetchTests() {
 
    $('.loader-bg').fadeIn();
 
    var self = this;
 
    this.categoryProduct.getTestFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(function(res: any) {
 
        self.categories =
          (res && res.data && res.data.category)
            ? res.data.category
            : [];
 
        self.ks3Categories = self.extractKs3Categories(self.categories);

        console.log("KS3 Categories", self.ks3Categories);
 
        var catIds = [];
 
        for (var i = 0; i < self.ks3Categories.length; i++) {
          catIds.push(String(self.ks3Categories[i].category_id));
        }

        console.log("Category IDs", catIds);
 
        var formData: any = {
          release: 'new',
          page: 1,
          user_id: +localStorage.getItem('userid') || 0,
          course: [],
          category: catIds,
          type: [],
          search: self.filters.search || '',
          exam_type: self.mapExamType(self.filters.mode)
        };
 
        self.allTests = [];
 
        self.fetchPage(formData);
 
      }, function() {
        $('.loader-bg').fadeOut();
      });
 
  }
 
  private fetchPage(formData: any) {
 
    var self = this;
 
    this.categoryProduct.getTestList(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(function(res: any) {
 
        var chunk = (res && res.data) ? res.data : [];
 
        var extra =
          (res && res.extra && res.extra.extraCount)
            ? res.extra.extraCount
            : 0;
 
            console.log("API returned", chunk);

        for (var i = 0; i < chunk.length; i++) {
          self.allTests.push(chunk[i]);
        }
 
        if (extra > 0) {
          formData.page = formData.page + 1;
          self.fetchPage(formData);
          return;
        }
 
        $('.loader-bg').fadeOut();

        console.log("Before filter", self.allTests.length);
console.log(self.allTests[0]);
 
        // Backend category filtering is unreliable — enforce the
        // KS3 category IDs client-side against the full fetched list.
        self.allTests = self.filterByKs3CategoryIds(self.allTests);

        console.log("After filter", self.allTests.length);
 
        self.centers = self.buildCenters(self.allTests);
 
        self.testList = self.applyLocalFilters(self.allTests);
 
        self.ref.detectChanges();
 
      }, function() {
        $('.loader-bg').fadeOut();
      });
 
  }
 
  // ============================================================
  // APPLY FILTERS
  // ============================================================
 
  applyFilters() {
    this.testList = this.applyLocalFilters(this.allTests);
    this.ref.detectChanges();
  }
 
  resetFilters() {
 
    this.filters = {
      categoryId: null,
      mode: null,
      month: null,
      center: null,
      search: ''
    };
 
    this.applyFilters();
 
  }
 
  private applyLocalFilters(source: any[]): any[] {
 
    var list = source.slice(0);
 
    // CATEGORY (Year Group)
 
    if (this.filters.categoryId) {

    var tmpCat: any[] = [];

    for (var i = 0; i < list.length; i++) {

        var year = String(list[i].school_year);

        if (
            (this.filters.categoryId == 45 && year === '7') ||
            (this.filters.categoryId == 46 && year === '8') ||
            (this.filters.categoryId == 47 && year === '9')
        ) {
            tmpCat.push(list[i]);
        }

    }

    list = tmpCat;
}
 
    // MODE
 
    if (this.filters.mode && this.filters.mode !== 'Both') {
 
      var mode = (this.filters.mode + '').toLowerCase();
 
      var tmp3: any[] = [];
 
      for (var k = 0; k < list.length; k++) {
 
        var et =
          ((list[k].exam_type || '') + '')
            .toLowerCase();
 
        if (
          mode.indexOf('online') !== -1 &&
          et.indexOf('online') !== -1
        ) {
          tmp3.push(list[k]);
        }
 
        else if (
          (
            mode.indexOf('face') !== -1 ||
            mode.indexOf('classroom') !== -1
          ) &&
          et.indexOf('classroom') !== -1
        ) {
          tmp3.push(list[k]);
        }
 
      }
 
      list = tmp3;
    }
 
    // MONTH
 
    if (this.filters.month) {
 
      var m = this.filters.month;
 
      var tmp4: any[] = [];
 
      for (var a = 0; a < list.length; a++) {
 
        var dateStr =
          (list[a].test_date || '').trim();
 
        if (dateStr.indexOf('-') !== -1) {
 
          var parts = dateStr.split('-');
 
          var start = this.parseDate(parts[0]);
 
          var end = this.parseDate(parts[1]);
 
          if (start && end) {
 
            if (
              (start.getMonth() + 1) === m ||
              (end.getMonth() + 1) === m
            ) {
              tmp4.push(list[a]);
            }
 
          }
 
        } else {
 
          var d = this.parseDate(dateStr);
 
          if (d && (d.getMonth() + 1) === m) {
            tmp4.push(list[a]);
          }
 
        }
 
      }
 
      list = tmp4;
    }
 
    // CENTER
 
    if (this.filters.center) {
 
      var c =
        (this.filters.center + '')
          .toLowerCase();
 
      var tmp5: any[] = [];
 
      for (var b = 0; b < list.length; b++) {
 
        var loc =
          ((list[b].location || '') + '')
            .toLowerCase();
 
        var al =
          ((list[b].all_location || '') + '')
            .toLowerCase();
 
        if (
          loc.indexOf(c) !== -1 ||
          al.indexOf(c) !== -1
        ) {
          tmp5.push(list[b]);
        }
 
      }
 
      list = tmp5;
    }
 
    // SEARCH
 
    if (
      this.filters.search &&
      this.filters.search.replace(/\s+/g, '') !== ''
    ) {
 
      var s =
        (this.filters.search + '')
          .toLowerCase();
 
      var tmp6: any[] = [];
 
      for (var z = 0; z < list.length; z++) {
 
        var blob =
          JSON.stringify(list[z]).toLowerCase();
 
        if (blob.indexOf(s) !== -1) {
          tmp6.push(list[z]);
        }
 
      }
 
      list = tmp6;
    }
 
    // SORT
 
    list.sort((a: any, b: any) => {
 
      var da = this.extractFirstDate(a.test_date);
 
      var db = this.extractFirstDate(b.test_date);
 
      if (!da && !db) return 0;
 
      if (!da) return 1;
 
      if (!db) return -1;
 
      return da.getTime() - db.getTime();
 
    });
 
    return list;
 
  }
 
  // ============================================================
  // HELPERS
  // ============================================================
 
  private parseDate(dateStr: string): Date | null {
 
    var clean = dateStr
      .replace(/\s+/g, '')
      .replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
 
    var d = new Date(clean);
 
    return isNaN(d.getTime()) ? null : d;
 
  }
 
  private extractFirstDate(range: string): Date | null {
 
    if (!range) return null;
 
    var part = range.split('-')[0].trim();
 
    return this.parseDate(part);
 
  }
 
  // Filters the fetched categories list down to Year 7 / 8 / 9
  // (category_id 45, 46, 47) rather than matching on name text.
  private extractKs3Categories(all: any[]): any[] {
 
    var out: any[] = [];
 
    for (var i = 0; i < (all || []).length; i++) {
 
      var cid = Number(all[i].category_id);
 
      if (this.KS3_CATEGORY_IDS.indexOf(cid) !== -1) {
        out.push(all[i]);
      }
 
    }
 
    return out;
 
  }
 
  // Client-side safety net: keep only tests whose category_id is
  // 45, 46 or 47, since the backend's category array param is
  // not reliably honoured.
  private filterByKs3CategoryIds(list: any[]): any[] {

  return list.filter(item => {
    const year = String(item.school_year).trim();

    return year === '7' || year === '8' || year === '9';
  });

}
 
  private mapExamType(mode: any): string {
 
    var m = (mode || '').toLowerCase();
 
    if (m.indexOf('online') !== -1) {
      return 'online';
    }
 
    if (
      m.indexOf('face') !== -1 ||
      m.indexOf('classroom') !== -1
    ) {
      return 'classroom';
    }
 
    return 'both';
 
  }
 
  private buildCenters(list: any[]): string[] {
 
    var set: any = {};
 
    for (var i = 0; i < (list || []).length; i++) {
 
      var v =
        ((list[i].all_location || list[i].location || '') + '')
          .trim();
 
      if (v) {
        set[v] = true;
      }
 
    }
 
    var out: string[] = [];
 
    for (var k in set) {
      if (set.hasOwnProperty(k)) {
        out.push(k);
      }
    }
 
    out.sort();
 
    return out;
 
  }
 
  trimChar(str: string, length: number = 30) {
 
    if (!str) return '';
 
    return str.length < length
      ? str
      : str.substring(0, length) + '...';
 
  }
 
  // ============================================================
  // DATE METHODS
  // ============================================================
 
  isRangeDate(date: string): boolean {
 
    if (!date) return false;
 
    return date.indexOf('-') !== -1;
 
  }
 
  hasDate(date: string): boolean {
    return !!date && date.trim() !== '';
  }
 
  getDateDay(date: string): string {
 
    var d = this.extractFirstDate(date);
 
    if (!d) return '--';
 
    return ('0' + d.getDate()).slice(-2);
 
  }
 
  getDateMon(date: string): string {
 
    var d = this.extractFirstDate(date);
 
    if (!d) return '--';
 
    return d.toLocaleString('default', {
      month: 'short'
    });
 
  }
 
  getDateYr(date: string): string {
 
    var d = this.extractFirstDate(date);
 
    if (!d) return '--';
 
    return d.getFullYear().toString();
 
  }
 
  // ============================================================
  // SUBJECT TAG
  // ============================================================
 
  getSubjectTag(name: string): any {
 
    var n = (name || '').toLowerCase();
 
    if (n.indexOf('math') !== -1) {
      return {
        label: 'Maths',
        cls: 'maths'
      };
    }
 
    if (n.indexOf('english') !== -1) {
      return {
        label: 'English',
        cls: 'english'
      };
    }
 
    if (
      n.indexOf('biology') !== -1 ||
      n.indexOf('chemistry') !== -1 ||
      n.indexOf('physics') !== -1 ||
      n.indexOf('science') !== -1
    ) {
      return {
        label: 'Science',
        cls: 'science'
      };
    }
 
    if (
      n.indexOf('verbal') !== -1 &&
      n.indexOf('non') === -1
    ) {
      return {
        label: 'Verbal Reasoning',
        cls: 'vr'
      };
    }
 
    if (n.indexOf('non-verbal') !== -1 || n.indexOf('non verbal') !== -1) {
      return {
        label: 'Non-Verbal Reasoning',
        cls: 'nvr'
      };
    }
 
    return {
      label: 'KS3',
      cls: 'default'
    };
 
  }
 
  // Maps a test's category_id to a readable Year Group label
  getYearGroupLabel(categoryId: any): string {
 
    var cid = Number(categoryId);
 
    if (cid === 45) return 'Year 7';
    if (cid === 46) return 'Year 8';
    if (cid === 47) return 'Year 9';
 
    return '';
 
  }
 
  // ============================================================
  // UI METHODS
  // ============================================================
 
  filterByCentre(center: string) {
 
    this.filters.center = center;
 
    this.applyFilters();
 
    setTimeout(() => {
      this.scrollToCalendar();
    }, 100);
 
  }
 
  setMode(mode: any) {
 
    this.filters.mode = mode;
 
    this.applyFilters();
 
  }
 
  loadMore() {
    this.visibleCount += 12;
  }
 
  toggleFaq(index: number) {
 
    if (this.openFaq === index) {
      this.openFaq = null;
    } else {
      this.openFaq = index;
    }
 
  }
 
  // ============================================================
  // SCROLL
  // ============================================================
 
  autoScorll() {
 
    if (this.shouldAutoScroll) {
 
      setTimeout(() => {
        this.scrollToCalendar();
      }, 200);
 
    }
 
  }
 
  scrollToCalendar() {
 
    const offerElement =
      document.getElementById('calendar-section');
 
    if (offerElement) {
 
      offerElement.scrollIntoView({
        behavior: 'smooth'
      });
 
    }
 
  }
 
  // ============================================================
  // DOWNLOAD
  // ============================================================
 
  downloadCalendar() {
 
    // TODO: replace with the actual KS3 calendar file link
    window.location.href =
      'https://drive.google.com/uc?export=download&id=REPLACE_WITH_KS3_FILE_ID';
 
  }
 
  downloadSchedule() {
    this.downloadCalendar();
  }

}
